export const TOGGLE_INCLUDE_SUBTASKS =
	'state.actions.workload-modal.TOGGLE_INCLUDE_SUBTASKS' as const;
export const SET_INCLUDE_SUBTASKS = 'state.actions.workload-modal.SET_INCLUDE_SUBTASKS' as const;

export type ToggleIncludeSubtasksAction = {
	type: typeof TOGGLE_INCLUDE_SUBTASKS;
};

export const toggleIncludeSubtasks = (): ToggleIncludeSubtasksAction => ({
	type: TOGGLE_INCLUDE_SUBTASKS,
});

export type SetIncludeSubtasksAction = {
	type: typeof SET_INCLUDE_SUBTASKS;
	payload: {
		includeSubtasks: boolean;
	};
};

export const setIncludeSubtasksAction = (includeSubtasks: boolean): SetIncludeSubtasksAction => ({
	type: SET_INCLUDE_SUBTASKS,
	payload: {
		includeSubtasks,
	},
});

export type Action = ToggleIncludeSubtasksAction | SetIncludeSubtasksAction;
